import $ from "jquery";

function init() {
}

function getQueryStringFilters() {
    const filters = getFilters();
    for (const key in filters) {
        if (!filters[key]) {
            delete filters[key];
        }
    }
    return filters;
}

function getFilters() {
    return {
        startDate: $("#dateRangeStart").val() || null,
        endDate: $("#dateRangeEnd").val() || null,
        programId: $("#programId").val() || null,
        courseTypeId: $("#selectCourseType").val() || null,
        courseLengthId: $("#selectCourseLength").val() || null,
        courseEditionId: $("#selectCourseEdition").val() || null
    };
}
function toIntOrNull(val) {
    const parsed = parseInt(val);
    if (isNaN(parsed)) { return null; }
    return parsed;
}

export const courseReportSummaryFilters = {
    init: init,
    getFilters: getFilters,
    getQueryStringFilters: getQueryStringFilters
};